import React from "react";
import { Checkbox } from "primereact/checkbox";
import styled from "styled-components";

export interface CheckboxProps {
  id?: string;
  label: any;
  checked: boolean;
  onCheckboxChanged: (checked: boolean) => void;
}

const MyCheck = styled(Checkbox)`
  .p-checkbox-box.p-highlight {
    background: #dd052b;
    border-color: #dd052b;
    &:hover {
      background: #af0423 !important;
      border-color: #af0423 !important;
    }
  }
  .p-checkbox-box {
    &:hover {
      border-color: #dd052b !important;
    }
  }
  .p-checkbox-box:not(.p-disabled).p-focus {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
  }
`;
const CheckButton = styled(Checkbox)`
  .p-checkbox-box.p-highlight,
  .p-checkbox-box.p-highlight.p-focus {
    background: transparent;
    border-color: #484848;
    .p-checkbox-icon {
      color: #484848;
    }
    &:hover {
      background: grey !important;
      border-color: grey !important;
    }
  }
  .p-checkbox-box {
    border-color: #484848 !important;
    &:hover {
      border-color: red !important;
    }
  }
`;

export const CustomCheck: React.FC<CheckboxProps> = ({
  id,
  label,
  onCheckboxChanged,
  checked,
}) => (
  <div>
    <MyCheck
      inputId={id}
      style={{ boxShadow: "unset !important" }}
      onChange={(e) => onCheckboxChanged(e.checked)}
      checked={checked}
    ></MyCheck>
    <label htmlFor={label} className="p-checkbox-label">{label}</label>
  </div>
);

export const ButtonCheck: React.FC<CheckboxProps> = ({
  label,
  onCheckboxChanged,
  checked,
}) => (
  <>
    <CheckButton
      onChange={(e) => onCheckboxChanged(e.checked)}
      checked={checked}
    ></CheckButton>
    <label className="p-checkbox-label">{label}</label>
  </>
);
